import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SalesDiscount } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesDiscountService extends TmsWebBaseEditService<SalesDiscount, SalesDiscount> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesDiscount', $localize`Sales Discount`);
  }
}
